export const HERO_BANNER_CONTENT = {
    HEADING: 'CELEBRATE YOUR ACCOMPLISHMENTS',
    DESCRIPTION: 'Share your college graduation with family and friends using the time-honored tradition of personalized announcements.'
}